import { defineMessages, MessageDescriptor } from 'react-intl';

const messages: Record<string, MessageDescriptor> = defineMessages({
	paginationLabel: {
		id: 'commont.paginationLabel',
		defaultMessage: 'Viewing {from} to {to} items'
	}
});

export default messages;
